// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-5d76e6ec] {\n\tmargin-left: 0 !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
